/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.AccountRoleResource = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The AccountRoleResource model module.
   * @module model/AccountRoleResource
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>AccountRoleResource</code>.
   * A resource of an account that added to a role.
   * @alias module:model/AccountRoleResource
   * @class
   * @param accountId {String} The ID of the account.
   * @param roleId {String} The ID of the role that will be assigned to an account.
   */
  var exports = function(accountId, roleId) {
    var _this = this;

    _this['accountId'] = accountId;
    _this['roleId'] = roleId;

  };

  /**
   * Constructs a <code>AccountRoleResource</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AccountRoleResource} obj Optional instance to populate.
   * @return {module:model/AccountRoleResource} The populated <code>AccountRoleResource</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('accountId')) {
        obj['accountId'] = ApiClient.convertToType(data['accountId'], 'String');
      }
      if (data.hasOwnProperty('roleId')) {
        obj['roleId'] = ApiClient.convertToType(data['roleId'], 'String');
      }
      if (data.hasOwnProperty('expiration')) {
        obj['expiration'] = ApiClient.convertToType(data['expiration'], 'Date');
      }
    }
    return obj;
  }

  /**
   * The ID of the account.
   * @member {String} accountId
   */
  exports.prototype['accountId'] = undefined;
  /**
   * The ID of the role that will be assigned to an account.
   * @member {String} roleId
   */
  exports.prototype['roleId'] = undefined;
  /**
   * The expiration of the role that tied to the account. If no value set, it will never expire.
   * @member {Date} expiration
   */
  exports.prototype['expiration'] = undefined;



  return exports;
}));



